export const QUICK_CHECKOUT_CART_PAYMENT_FOOTER_ACCESSIBILITY_TEXTS = {
    CART_TOTAL: "Cart total is {0} Rupees",
};

export const QUICK_CHECKOUT_CART_PAYMENT_FOOTER_TEXTS = {
    ITEM_LABEL: "Item",
    FINAL_PRICE: "Final Price",
    PAY: "Pay",
};
